import { Transformer } from '@cp/ds/src/components/form';
import { CityViewModel } from '@common/model/location/cityViewModel';
import { useMemo } from 'react';
import { coreLocationApi } from '../api';
import { ICityOption, cityModelToOption } from './cityOption';

export class CityIdToName implements Transformer<number, string> {
  #options: ICityOption[];
  constructor(options: ICityOption[] = []) {
    this.#options = options;
  }
  setOptions(options: ICityOption[]) {
    this.#options = options;
  }
  toControl(cityId?: number) {
    return this.#options.find((option) => option.id === cityId)?.label;
  }
  fromControl(label: string) {
    return this.#options.find((option) => option.label === label)?.id;
  }
}

export class CityModelToName implements Transformer<CityViewModel | undefined> {
  #options: ICityOption[] = [];
  setOptions(options: ICityOption[]) {
    this.#options = options;
  }
  toControl(model?: CityViewModel) {
    return model?.translation.name;
  }
  fromControl(label: string) {
    return this.#options.find((m) => m.label === label)?.model;
  }
}

export const useCityIdTransformer = (cityId?: number) => {
  const { data } = coreLocationApi.endpoints.getCityById.useQuery({ id: cityId as number }, { skip: !cityId });
  return useMemo(() => new CityIdToName(data ? [cityModelToOption(data)] : []), [data]);
};
